import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOTerminListStatus: 'idle',
    loadTOTerminListError: undefined as any,
    loadTOTerminListLastArgs: undefined as any,
    loadTOTerminStatus: 'idle',
    loadTOTerminError: undefined as any,
    saveTOTerminStatus: 'idle',
    saveTOTerminError: undefined as any,
    deleteTOTerminStatus: 'idle',
    deleteTOTerminError: undefined as any,

    tOTerminList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOTerminList = createAsyncThunk('toTerminSlice/loadTOTerminList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toTerminSlice.loadTOTerminListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/?action=gte&MIN_MODULTYPE=3&MAX_MODULTYPE=3&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOTerminListStatus } = getState().toTerminSlice
        return loadTOTerminListStatus !== 'pending'
    }
})

export const loadTOTermin = createAsyncThunk('toTerminSlice/loadTOTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOTerminStatus } = getState().toTerminSlice
        return loadTOTerminStatus !== 'pending'
    }
})

export const saveTOTermin = createAsyncThunk('toTerminSlice/saveTOTermin', async ({ toTermin }: any, { rejectWithValue }: any) => {
    let promises = []
    if (toTermin?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristotermin/${ toTermin?.HDR_ID }/`,
            prepareData(toTermin),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristotermin/`,
            prepareData(toTermin),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOTerminStatus } = getState().toTerminSlice
        return saveTOTerminStatus !== 'pending'
    }
})

export const deleteTOTermin = createAsyncThunk('toTerminSlice/deleteTOTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuristotermin/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOTerminStatus } = getState().toTerminSlice
        return deleteTOTerminStatus !== 'pending'
    }
})

const TOTerminSlice = createSlice({
    name: 'toTerminSlice',
    initialState,
    reducers: {
        resetloadTOTerminListError: (state) => {
            state.loadTOTerminListError = undefined
        },
        resetloadTOTermin: (state) => {
            state.formItem = undefined
            state.loadTOTerminError = undefined
        },
        resetloadTOTerminError: (state) => {
            state.loadTOTerminError = undefined
        },
        resetsaveTOTermin: (state) => {
            state.formItem = undefined
            state.saveTOTerminError = undefined
        },
        resetsaveTOTerminError: (state) => {
            state.saveTOTerminError = undefined
        },
        resetdeleteTOTerminError: (state) => {
            state.deleteTOTerminError = undefined
        },
        removeFromTOTerminListById: (state, action) => {
            state.tOTerminList = state.tOTerminList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTOTerminListByIds: (state, action) => {
            state.tOTerminList = state.tOTerminList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tOTerminList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOTerminListStatus = 'preloaded'
            state.loadTOTerminListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tOTerminList = []
            state.loadTOTerminListStatus = 'idle'
            state.loadTOTerminListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOTerminList.pending, (state) => {
            state.loadTOTerminListStatus = 'pending'
            state.loadTOTerminListError = undefined
        })
        builder.addCase(loadTOTerminList.fulfilled, (state, action) => {
            state.loadTOTerminListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOTerminListLastArgs = action.payload.args

            {
                state.tOTerminList = action.payload.data

            }
        })
        builder.addCase(loadTOTerminList.rejected, (state, action) => {
            state.loadTOTerminListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOTerminListError = action.error.message
            } else {
                state.loadTOTerminListError = action.payload
            }
        })

        builder.addCase(loadTOTermin.pending, (state) => {
            state.loadTOTerminStatus = 'pending'
            state.loadTOTerminError = undefined
        })
        builder.addCase(loadTOTermin.fulfilled, (state, action) => {
            state.loadTOTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOTerminList.push(newItem) }
                else { state.tOTerminList[i] = { ...state.tOTerminList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOTermin.rejected, (state, action) => {
            state.loadTOTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOTerminError = action.error.message
            } else {
                state.loadTOTerminError = action.payload
            }
        })

        builder.addCase(saveTOTermin.pending, (state) => {
            state.saveTOTerminStatus = 'pending'
            state.saveTOTerminError = undefined
        })
        builder.addCase(saveTOTermin.fulfilled, (state, action) => {
            state.saveTOTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOTerminList.push(newItem) }
                else { state.tOTerminList[i] = { ...state.tOTerminList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOTermin.rejected, (state, action) => {
            state.saveTOTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOTerminError = action.error.message
            } else {
                state.saveTOTerminError = action.payload
            }
        })

        builder.addCase(deleteTOTermin.pending, (state) => {
            state.deleteTOTerminStatus = 'pending'
            state.deleteTOTerminError = undefined
        })
        builder.addCase(deleteTOTermin.fulfilled, (state, action) => {
            state.deleteTOTerminStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tOTerminList = state.tOTerminList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tOTerminList = state.tOTerminList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOTermin.rejected, (state, action) => {
            state.deleteTOTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOTerminError = action.error.message
            } else {
                state.deleteTOTerminError = action.payload
            }
        })

    }
})

export const {
    resetloadTOTerminListError,
    resetloadTOTermin,
    resetloadTOTerminError,
    resetsaveTOTermin,
    resetsaveTOTerminError,
    resetdeleteTOTerminError,
    removeFromTOTerminListById,
    removeFromTOTerminListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TOTerminSlice.actions
export default TOTerminSlice.reducer
